<template>
  <el-table ref="singleTable" :data="allData" :max-height="tableHeight-40" stripe style="width: 100%">
    <el-table-column type="index" width="50" label=" " align="center">
      <template slot-scope="scope">
        <span>{{scope.$index+index+1}}</span>
      </template>
    </el-table-column>
    <el-table-column property="roadcode" :label="roadName + '代码'" align="center"></el-table-column>
    <el-table-column v-if="showProvinceName" property="roadname" :label="roadName + '名称'" align="center"></el-table-column>
    <el-table-column v-if="showWayProvinceDetail" property="wayProvince" :render-header="renderChannel" align="center" minWidth="350">
      <template slot-scope="scope">
        <div style="min-height: 50px; display:flex; align-items:center; cursor: pointer;">
          <span style="flex:8;">{{scope.row.wayProvince}}</span>
          <span style="color:#1137FF;flex:2;border-left:1px solid #ccc;" @click="$emit('on-to-detail', scope.row.roadcode)">各省分段<br/>数据统计</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column v-else property="wayProvince" label="所属省份" align="center" minWidth="130"></el-table-column>
    <el-table-column property="driverVehicleCount" minWidth="150" :render-header="renderCar" align="center">
      <template slot-scope="scope">
        <span>{{format(scope.row.driverVehicleCount)}}</span>
      </template>
    </el-table-column>
    <el-table-column property="driverVehicleMile" minWidth="110" :render-header="renderStopLabel" align="center">
      <template slot-scope="scope">
        <span>{{format(scope.row.driverVehicleMile)}}</span>
      </template>
    </el-table-column>
    <el-table-column property="stopSubtotal" :render-header="renderStop" align="center" minWidth="150">
      <template slot-scope="scope">
        <span>{{format(scope.row.stopSubtotal)}}</span>
      </template>
    </el-table-column>
    <el-table-column property="stopSinopec" :render-header="renderStone" align="center" minWidth="130">
      <template slot-scope="scope">
        <span>{{format(scope.row.stopSinopec)}}</span>
      </template>
    </el-table-column>
    <el-table-column property="stopPetrochina" :render-header="renderOil" align="center" minWidth="130">
      <template slot-scope="scope">
        <span>{{format(scope.row.stopPetrochina)}}</span>
      </template>
    </el-table-column>
    <el-table-column property="stopOther" :render-header="renderOther" align="center" minWidth="130">
      <template slot-scope="scope">
        <span>{{format(scope.row.stopOther)}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { format } from './util'
import nameMixin from './nameMixin'

export default {
  mixins: [nameMixin],
  props: {
    allData: {
      type: Array,
    },
    index: {
      type: Number,
    },
    toDetail: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      format,
    }
  },
  methods: {
    renderStart(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAD0SURBVDiNzdQxC8IwEIbht0ERRHDqJIKCe10dLLgJgvhfxUGpuugqOOsiuHSwYKGTSBxEUJqmp3TwGxPyJBcucbTWmgKjisQAStbZ6xX2ezifQSloNsHzoFbLXOIYS9Ya1muYz+F2+5yrVGA8hl7vC3A2g+XSengmE/D91HD6Dk8nWK3sGMB0CpeLANxsniXn5X6H7VYAHg752CvHowCMYzmYJALQ0hKpVKsCsNORg+22ADS0gjFKQb8vAFstGToageumhrNfymIBQfBsj/eUyzAcwmBg3McMvhJFsNtBGILjQKMB3S7U65lL7OAPKfz7+n/wAXA0T/sogItrAAAAAElFTkSuQmCC"
          />
          起点
        </span>
      )
    },
    renderEnd(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAEzSURBVDiNY/z///9/BioCJmoaxsDAwMCCT/Lt788Mhz9dZ3j08w0DEwMjgxKHOIM1nwYDPwsXTj2M2Lz8n4GBYd2bEwzLXx9h+PXvD4ocBxMbQ6K4I4OnkCHxBi56eZBhzZvj+BzPkCLhzOAnbIohjhGGt74/Y1hLwDAGBgaG+S/3M7z49YGwgVvenmUgJtr//v/HsPXdWcIGXvz6kAjjIODK18eEDXz/5wvRBn76+42wgfiSBDrgYeYgbKAutxzRBmpxyRA20E8IMylgA8yMTAzeQsaEDdTgksaavtBBtJgdgwy7MIY4zpyy7NVhhrVvTjD8+f8XRY6NiYUhWtSWIVDEHKtFWA2EgZe/PjAc/HiN4cnPtwyMjIwM8uyiDPb8WgzCrLw4XY7XQHIA1YuvwW8gAOkQZfYgT2LvAAAAAElFTkSuQmCC"
          />
          终点
        </span>
      )
    },
    renderChannel(h, { column }) {
      return (
        <span>
          <img
            style="display:inline-block;vertical-align:middle;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAH5SURBVDiNrZTPS1RRFMc/T8ZxmMERTRk0kAlBUwfFcdxIRmUuooU7f9SiwH9AVHJTCLYKEZICCSqCoB+UULRzXURIlL/RMbQfJEGkNpM6Tcx1cRje8903qeAXLpx3zvl+77nn3HcNpZTiEOHKFEj+g/EJeD0F33+K72gRnKiBlghkZ2AaThVuxOHGI/jyw5kULIYrneD36bEsu0MBI893i5UGZKWxsgq3xiTXDq3wj1FY/Cp2tgt6OyB0TL7nVmDosbRj/jNMf4Kasj0q/LBo2mfCphhAVRBO1Vlyo3qFmuDGH9M+kqcTCi2+9dg+BK2EiXlIWRqlFLxf+P+GmmBduWlHv8HwE5hZlv7dfGb2FyBcbmc7DKU6CCWF5t2bXJJlR2kAKoP7qNAwoO20nmhHRzMYDn5NECByHOorMos1hvTr4ij4bg4G7sNaDLrOQ36uTgjkw+Vz8Os3DNyTwTkKLq/CnZdwslaE/D7obgO3pcveHOhpB68HCvzQVAujL+TP2SW4FpNpNlRCc70ZLCuBvk4RyvVC/0V5INI4G4FwBQw/hfW4+IxEUqnrDyCRhMEu8Lj1Y8a3ZFg+jx7b/gvX7sqmVy+BcXtMqbezcgxvjk7wuKG1CVIpePVGBOzYTMDmtgzL8fmyYnIJHo6DKwsutGSebhp7Ch4UO5Wilf5d1uDzAAAAAElFTkSuQmCC"
          />
          途经省份
        </span>
      )
    },
    renderStopLabel(h, { column }) {
      return h('span', [h('span', '运营里程')])
    },
    renderCar(h, { column }) {
      return h('div', {
        props: {
          content: (function () {
            let label = '行驶车辆数'
          })(),
        },
        domProps: {
          innerHTML:
            "<img style='display:inline-block;vertical-align:middle;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAHlSURBVDiNzZRNbxJRFIafO9BJOhCEdqqAowkSP8aSVtCFujJGu3Bpa+jCpP0Dbo07/0ATN25dsKmV+LFzo3FpNKnfFujCGNM6hUiV6tAiWMbFlKFpLMOChWd1c/LeJ+c959wrLMuy6GF4dyYWV6tce7xAoWy6Xj6m+rl9aZgjgz4nJ3ZWePneK+aNNU6EA+z1ybvCvlXrvCn+5LQWJHsl9e8KP31fZ95YIxZUeDR5Eo8QuwKblsX5zEteLFf4XFknFlQAkLaLsrkVANKJSEcYgCQEk4koAPdzxXa+ddi0LB7mi0hCMK6HO8JaMa6H8QjBg1yR5lbnvK3y77xeomT+ZsgnM/vB6AoIoPpkjF81Mm+/Mp3U7KHceFpwIIP9fRxV/Txf+uEKO3sgxGLZZHWjAcDUqGZbzi6sOKKZMZ25iSSpSKAjLBUJMDeRZGZMd3J3Pxo28E+zvTn5skml1qBk1jsCS9U6lVqD/LZ9rW82bcsHbz1ztddtSO6S/wEouSxxtyHYesv5ssnse4PMu2UAjg/5uXnusCvg+pMCXyobAKSHI6QTUXuxddVPfEBxhAP9Mme0kCtQVWQHOLIvwKnonnYPLx5SiQUV/LKXqyP7u7I4Narh6/MQDylciKu27V5/sD2f8l8me6c5nSO4wgAAAABJRU5ErkJggg=='/> 行驶车辆数",
        },
      })
    },
    renderStop(h, { column }) {
      return h('div', {
        props: {
          content: (function () {
            let label = '停靠小计'
          })(),
        },
        domProps: {
          innerHTML:
            "<img style='display:inline-block;vertical-align:middle;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAKxSURBVDiNrZRdSFNhGMf/m578mNuUVERCh5YfZ+QynRBeFiVBYIHYRQWBKCHYx6QuuoggisKpBUJkF1GilYRJElgO9EI0j2a6dpxOxZk4saHT+dmZ5+lGj1Oby+h/+T7/98f7f56XR0ZEhP8ouT+DxeXE2db3CKgpQ25rAywu565+ma8Xji3M4U5fO16NWuBtkAG4mKDFXV02NGFq/8DplSXcM3fg6dA3CKLo8yWMXI4rSUdw+/AxRAeH7gTOCasw8hzK+W4seoRdY3lLEcjgBpsJA6uHmgnaBOqaXqB/9udfg7ZLGx6J72cubw4lVb3/n2EAoIuIArCth32z0yjjObwZs+7avw0xcjnyNSkoZfXQRURvBU4uLyA2JAwAMLHkxhPrVzwb6sOcsLoDpGaCUJikQ0nKURwIVcL7vgRMbKjGqVgNDKweicpwAIBb+IXnw/2oHOjB+OI84hQqXEvNQMHBNCiZfQCAEbcLRp7DZ4cdttwCgNZlm5+hos5mUtRWUF5bI3FOx0aJPKJIvMtJHlGUzjing/LaGklRW0FFnc1km58hIqId/9C5uoyqwV5UDfYiLTwKN7VZOBmrkeqfJsfw0PIFZpcTxcnpKE5OR2RQiFSXgJfaP8LAZkrNXV7zoGaUh5HnEBwQiPOaFLwes2JlzQMDq8eFBBYhAYHSMI18N15mn96MfN/cQaq6SsppqSeTwy5FWxNF+vBjmEq6WqhpYoTWvGKbHHbKaaknVV0lPTB37ow8J6yi2taPxwM9iAlR4JY2C+fikiCXyaRIIhHejQ/hkaULU8uLuJqagcJDOqjWh/TH5SCIIt7arTDyHNyCgFJWj7z4ZNTbB1HGc1AyDAysHvmaFATKti4sn9tmQ6YpO8r5bpim7DgRE4/rbCaOx8T79PsF7lV+F+xe9RvZSoWCrOOqqgAAAABJRU5ErkJggg=='/> 停靠小计",
        },
      })
    },
    renderStone(h, { column }) {
      /*停靠中国石化*/
      return (
          //       <img
          //   style="display:inline-block;vertical-align:middle;"
          //   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAN0SURBVDiNrZRbbxtVFEbXmTlz8SW1x3F8i5NIVWoRakjSIBEQLaiAKoSE+DG88MrvyQsPSEgFVaFUlarSFGqauLit6hA7ji9xEt9nPIeHlpBgJITEet5n6fvOlrZQSileMVaKAS6W0JBIlOsxPD6h22iCENjRKexoBGEajPCQvo4UOghOkZxBoDCFRKLht1tU7z+kWa6AlEhLoimBPRMnsXoZOxZHaaDUOR/iz4SeUkghwPepbN6h8O03bL8oE0zN8u6nN0jPZuk2WnT29hm222SvrjGdXwYFoBBCnE/oCwFjn/3bd3myucnNnQJlBVcSy0TyS8TSs0Q9j0GzRePnXynfvIXyFPGVlVfSv1WWQOO3J9QLD0lce4das0q9/BxXeeji5ZgmJYFkgvnrMTRNY3fzDqFkgmA6cyrUThP2+1Tu/4SznCe+9hZyBCeVGs3DOpZhnP1qfCmZff89DCdC7UEB3xtPCvsHNbyDI1JvrzNwh8hRl6PWIY1Wm2AweGZxLx8JQ2fh6jrNaplh92iycq9Vw3YcpGlhKvANnYHr0ao12N7ZRuo6tm0jDRM7aOC6YEkT3+vg9doQiZ0Xev0BVmQKzx/TbjTRhUTTdXrdDoVCgXqjgdR0glNhMnMpTo6HLMSimK6PcNVkwnAoQr21y91791Cuh2kYKH+MHQiQy+VIZzL8Xt4lEA4zM5PEiYyJCsFQmGhGaFJopVJslb8mEAuw8uYyYwSeO8ayLPL5PKFQiNp+DdMymbowhdQljUe/UJUB9OBfwtOl7B6f8LhaYT13icT0NGMlMK0AutCwbRuAZCqJ4zhIXYI7or1TIrn0OkYoOJlwd69KtVoj3GjRHQyxdMFMOoUVCFAsFonH43Q6HYLhIHg+7afPefH0GatrywipTwrn57Pkr6zw/Xe3cLJJAlKRzaZBaGxsbJBIJGg1W1gXQojBkLQM8qxxwPDxIz6ZX8CQ8rxw8eJFbnz+GV998SVLb+TA1rFNyaDXo1gsUiqVUL6i0+8xGg34+NqH7Pf6xPYOcF13Uliv1/nh9o8ceENWk0mE8kkMFEbaRCmFbdsctdsszM1x4g2JJuM47UNijoOu/0Pler3O1tYDLr+W46MPrlMqlZiJJYg6UXRdxzRNqtUKi4uXGI1GZDIZDE0jlUwgzwjF2QP7f6D9+8h/4w9QHWety5uV6AAAAABJRU5ErkJggg=="
          // />
        <span>

          停靠S级油站
        </span>
      )
    },
    renderOil(h, { column }) {
      /*停靠中国石油*/
      return (
          //   <img
          //   style="display:inline-block;vertical-align:middle;"
          //   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAAM5SURBVDiNrZNNbBtVFIW/N29mPJPYThPSuJSEtJgmDX+qqtIVSNlQ6IYKqYrEhh+xQOxYskBCXbFgExaVEDskFkgIgUAQMDukChxEsVoStSSQ4NAm2E1sx4k99njeZRHXjZErJMSR3ub93HvOO+cqERH+R9h3O2j8+h3RF2+gUqPIo89C4RpcySBHnsB77h0sSyNEnfsW+u4FW2ETLs0SK11Hwjyh3sLaXMPeKRItbhE+cgZ38hkUGkEA05thq1bCLH5Fo3AZu/ANur8GDoTiodUKOm5Q1RLV+Xdh4yrW0Wns+x8HVKeGuv2HEoUEH72GszRH1L9FeOw0fTvzWFZAMHoGp5RDlwsEyZOY0ibujS0iO416/j2c8VMopdvS25AoRF//BLtxk5gX4MTKNCfOIkNgDcZRyTrh+BRy6Ci+LmDbVdy1HLJ+lf22diQbE9A6mEL5Ptov4zSuEPqjhEdOgw+RHsPETuDmM+DViUbvIXJsIuo4lu4uaIDmTx+gzA6t4RGigTQ6obB0BXPoHDr2GBJVYDuDDB2j6Z9AqrvQXIfFjzEPn8dK3nunYLixgMq8jecXMds74B8AfwDG0jiJGeDBPRXxdYQ19OqfUC2jghJqdZXg0vvYZ9/aJ7lRR28XUUnQsSokErTUAPU/JgnyCzSXv8UZHMSdGsJNHKav7xb4u+A2oAVSudHtsmnUCL58HZY/p+ndRz0cZXfFIViuElxbIsqvYMWTuMcfwksfpm/KxR8q4Jnf0WEMPfMh7tip7tjUNpZYffEczXUIbzaINteAEAVo6I6vM4I9Pow9XCP16iukXnqzk8SOyzqWopzJo9lFAy6A6h4kDSAGCQuY5QKVZTgwMwJRBPofObQ9m+STJ1FtNihNT7T3BYglkvSlU6B6TApAJZul9OlnbGe+pvFzDo0FSHteac9uhEnESTz1NMnpaQ6+/AJOPHmnofRAOZuVyxMT8gNIFmS+v19+1FqyIN9blvx24YI067VeT6WL4X4U5+YoXLyIOzKCN3kcUy5Ty+WwJyd4YHa2Y5SSPf7qtuyebUQkEpHK4qIExb9ERKQVhlL5ZUHqt4r7bhkxZm/9K8P/ir8Bk63MWM/328MAAAAASUVORK5CYII="
          // />
        <span>

          停靠C级油站
        </span>
      )
    },
    renderOther(h, { column }) {
      /*停靠其他油站*/
          //  <img
          //   style="display:inline-block;vertical-align:middle;margin-right:5px;"
          //   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB90RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgOLVo0ngAAANHSURBVDiNrZRfTFtVHMc/5/aW9dJCYZXaNRVGHR0bSyNMjQRJs82wwR42cWEPJmYxxsSY+OarL+rTHoxRozFxD5tE1AS2mPiXrXNh6WRJtzEKki2bKRjRUaDhj2259/58GFPg8uDDvskvOTk5v885v98536NERHiI0jebFBF+vXWX/oFzJFPD3Jn6HV0pYvV1dCTaOfr8YWrD4f8PTI+M8vZ7p7iRGmYqN49ZKoJS5P7M8cedLLezk7z+ygl2NkQ3Pc06ffP9edn7VLtEtvkl0VQlHXtD0tVaK8+21EllMCxo1QIBad/fKUO/DG9MF7W2hyOZcXqOn2Aic40vXnuUeNRNsSQoTdAtxVuDiq2GTu/QEoWFGVoT++j7/BS1kf/K1x4MiqUS75x8n4lMGiMUJlrj5swVm4/OKz6+oCiagr/MIuizeLOzHK8/ROrnS5z84BNMy3ICr4+MMtB/FnxBdN1Fds7mwyHFZ0n4NKlITSr+WoTelBCttnjhaTe4K+nt7WNs4pbzUr4bvIC5sAg1IVZMC79H8W4XzC8Kmgva6oRzoxrZKeHsuKIzZnHaKGdueobkxUvEdzeuB6ZvZMAwQARLoMINbyQsMBUoQWzo3qNzMytM5oWCCWgKTddJ3xxzlpxfWALX2lckYIKYAqawVIAdAeFwXKFpsGKvLnNp5PMLTmCF14A1zRUACwomWJaiaCou37WJVN0fA6AAy6bCV+4ExnfvhMLfoBSmBaa1Sl0NTaBkKyxLMBR49PvbimkRb2p0Ag8e2IfmMaBUxFumUV0uYIDhAZcBXkOo2CLEHlEcahAsNFgu4AtUcSDR7gQ+2dJMR9dByN+jsUbw+jRmC4q5FcVsQbGsFJVbFOPTguZW/DBmQnGe7mNH2NO061/gOqdcuZqmp+cl9OXf6G7diq25QWzEhjI33M4pfsxolEmJ2ZkZmlqa6f/yDLEdazy90YunvxqQ7bFmAb+ggoLnMcFbtxoRwVUjUC3xJ9rk28Gkw8sOoIjITxeH5LkjL8r2+rh4gw3iCjwurkBUKkMxie1qkeMvvyrD165vlrr+c3gg27YZGRun7+t+Ll9NM30vhwZEwtvY3/YMPceO0hCt35jm7OHD0D8Rt879K40hswAAAABJRU5ErkJggg=="
          // />
      return (
        <span>
          停靠E级油站
        </span>
      )
    },
  },
}
</script>
